import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import { Nullable } from "src/common/types/common";
import { noticesBoard } from "src/common/types/noticesBoard";
import { CreateNoticeBoardInputs } from "./NoticeCreateModal";
import { modalNoticeBoardsSchema } from "src/components/molecules/Modals/ModalNoticeBoards/modal-notice-boards";
import { yupResolver } from "@hookform/resolvers/yup";
import { request } from "src/common/api";
import { BaseResponse } from "src/common/types/baseRespones";
import { GET_NOTICE_BOARDS } from "src/common/querykeys";
import { confirmDialog } from "../ConfirmDialog";
import { ModalNoticeBoards } from "src/components/molecules/Modals/ModalNoticeBoards";

interface NoticeBoardsUpdateModalProps {
  selectedNoticeBoards: noticesBoard;
  setModalShow: any;
  updateModalShow: any;
  formId: string;
}

export const NoticeUpdateModal = ({
  selectedNoticeBoards,
  setModalShow,
  updateModalShow,
  formId,
}: NoticeBoardsUpdateModalProps) => {
  const queryClient = useQueryClient();

  const { control, handleSubmit } = useForm<Nullable<CreateNoticeBoardInputs>>({
    resolver: yupResolver(modalNoticeBoardsSchema),
    defaultValues: {
      ...selectedNoticeBoards,
    },
  });

  // 수정하기
  const { mutateAsync: updateNoticeBoards } = useMutation({
    mutationFn: (inputs: any) => {
      return request<BaseResponse>({
        method: "PUT",
        url: `/notice-boards/${selectedNoticeBoards.oid}`,
        data: inputs,
      });
    },
    onSuccess: (res: BaseResponse) => {
      queryClient.invalidateQueries({ queryKey: [GET_NOTICE_BOARDS] });
      if (res.success) {
        setModalShow(false);
      }
    },
  });

  // 삭제하기
  const { mutateAsync: deleteNoticeBoards } = useMutation({
    mutationFn: (oid: string) => {
      return request<BaseResponse>({
        method: "DELETE",
        url: `/notice-boards/${oid}`,
      });
    },
    onSuccess: (res: BaseResponse) => {
      queryClient.invalidateQueries({ queryKey: [GET_NOTICE_BOARDS] });
    },
  });

  const handleDelete = async () => {
    const isConfirm = await confirmDialog({
      text: "삭제할 항목을 삭제하시겠습니까?",
    });

    if (isConfirm) {
      deleteNoticeBoards(selectedNoticeBoards.oid);
      setModalShow(false);
    }
  };

  return (
    <ModalNoticeBoards
      createModalShow={false}
      formId={formId}
      setModalShow={setModalShow}
      onSubmit={handleSubmit((data: Nullable<CreateNoticeBoardInputs>) => {
        updateNoticeBoards({ ...data });
      })}
      control={control}
      onDelete={handleDelete}
      updateModalShow={updateModalShow}
    />
  );
};
